import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { RoleClaim, Role } from './role-details.model';
import { RoleDetailsRest } from './role-details.rest';
import { GridComponent } from '../../../core/shared/grid/grid.component';
import { UserSelectionComponent } from '../user-selection/user-selection.component';
import { HasPermissions, Permissions } from '../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../core/services/permissions/permissions.service';
import { ObjectToSelect } from '../../../core/shared/objectToSelect.model';
import { MenuButton } from '../../../core/shared/tabmenu/tabmenu.model';

@Component({
    selector: 'app-role-details',
    templateUrl: './role-details.component.html',
    styleUrls: ['./role-details.component.scss']
})
export class RoleDetailsComponent implements OnInit, HasPermissions {
    permissions: Permissions;

    private menuButtons: MenuButton[]= [
        {text: 'COMMONBUTTONS_save', class: 'btn-success', icon: '', onClick: () => { this.saveRole(); }, enabled: true, isForSelected: false },
        {text: 'COMMONBUTTONS_close', class: 'btn-danger', icon: '', onClick: () => { this.close(); }, enabled: true, isForSelected: false }
    ];
    private saveButton = { text: 'COMMONBUTTONS_save', class: "btn-success", icon: '', onClick: () => { this.saveRole(); }, enabled: true, isForSelected: false };

    private claimsMenuButtons: MenuButton[] = [
        { text: 'Zaznacz/odznacz wszystko', class: "switch", icon: '', onClick: () => { this.selectUnselectAllClaimsChanged() }, enabled: true, isForSelected: false }
      ];
    
    private navigateMenuButtons: MenuButton[] = [
    { text: 'Zaznacz/odznacz wszystko', class: "switch", icon: '', onClick: () => { this.selectUnselectAllNavigationChanged() }, enabled: true, isForSelected: false }
    ];

    private headers = [
        { displayName: 'Użytkownik', propertyName: 'name', propertyType: 'string'},
        { displayName: 'Imię', propertyName: 'firstName', propertyType: 'string' },
        { displayName: 'Nazwisko', propertyName: 'lastName', propertyType: 'string' },
        { displayName: 'Email', propertyName: 'email', propertyType: 'string' },
        { displayName: 'Przełożony', propertyName: 'superior', propertyType: 'string' },
    ];

    private role: Role = new Role();
    private path: string;
    private isSaving = false;
    private selectUnselectAllClaims = false;
    private selectUnselectAllNavigation = false;

    @ViewChild(GridComponent) grid: GridComponent;
    @ViewChild(UserSelectionComponent)public userSelectionModal: UserSelectionComponent;

    setPermissions(claimType: string): void {
        this.permissions = this.permissionService.getUserPermissions(claimType);
    }

    @HostListener('document:keydown.control.s', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (this.userSelectionModal != null && this.userSelectionModal.modal.modalRoot.isShown === true) {
          return;
        }
        this.saveRole();
        event.preventDefault();
    }

    ngOnInit(): void {
        this.setPermissions('Role');
        this.path = `api/roles/role/${this.route.snapshot.params['RoleName']}/users/grid`;
        this.rest.getRoleDetails(this.route.snapshot.params['RoleName']).subscribe(result => {
            this.role = result;
        });
    }

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private rest: RoleDetailsRest,
        private permissionService: PermissionsService
    ) {}

    public tabChanged(tabChangeEvent: MatTabChangeEvent): void {
        return;
    }

    private getActionButtons() {
        return [];
    }

    public addUser() {
        const action = this.rest.getUsersToAdd;
        action.call(this.rest, this.role.roleName).subscribe((result: ObjectToSelect[]) => {
            if (result) {
                let roleName = this.role.roleName;
                if(!roleName)
                    return;
                this.userSelectionModal.roleName = roleName;
                this.userSelectionModal.selectUser(result);
            }
        });
    }

    private close() {
        this.router.navigate(['../../'], { relativeTo: this.route });
    }

    private selectUnselectAllClaimsChanged() {
        if (this.selectUnselectAllClaims) {
            this.role.roleClaims.forEach(claim => {
                claim.canAdd = false;
                claim.canEdit = false;
                claim.canDelete = false;
                claim.canShow = false;
                this.selectUnselectAllClaims = false;
            });
        } else {
            this.role.roleClaims.forEach(claim => {
                claim.canAdd = true;
                claim.canEdit = true;
                claim.canDelete = true;
                claim.canShow = true;
                this.selectUnselectAllClaims = true;
            });
        }
    }

    private selectUnselectAllNavigationChanged() {
        if (this.selectUnselectAllNavigation) {
            this.role.navigationElements.forEach(navigationElement => {
                navigationElement.isVisible = false;
                this.selectUnselectAllNavigation = false;
            });
        } else {
            this.role.navigationElements.forEach(navigationElement => {
                navigationElement.isVisible = true;
                this.selectUnselectAllNavigation = true;
            });
        }
    }

    public saveRole() {
        if (this.isSaving) {
            return;
        }
        this.isSaving = true;
        const action = this.rest.saveRole;
        action.call(this.rest, this.role).subscribe(() => {
            this.isSaving = false;
            this.close();
     });
    }

    public onSuccessOperation(value){
        if (value.isSuccess) {
            this.grid.refreshData();
        }
    }
}
